ACC.cartitem = {

    _autoload: [
        ['bindCartItem', $('.js-execute-entry-action-button a').length > 0],
        ['toggleBlock', $('.toggle-block').length > 0],
    ],
    _config: {
        testAnimate: false,
    },

    submitTriggered: false,

    bindCartItem() {
        $('.js-execute-entry-action-button a').on('click', function () {
            if (ACC.utils.isHedTheme()) {
                // eslint-disable-next-line newline-per-chained-call,max-len
                ACC.cartgtm.removeFromCartGtm($(this).closest('.item__description').find('.cart-item__ISBN .item__code').text().trim());
            } else {
                // eslint-disable-next-line newline-per-chained-call,max-len
                ACC.cartgtm.removeFromCartGtm($(this).closest('.item__description').find('.cart-item__ISBN').text().trim());
            }
            // eslint-disable-next-line no-unused-vars
            const entryAction = $(this).data('entryAction');
            const entryActionUrl = $(this).data('entryActionUrl');
            // eslint-disable-next-line no-unused-vars
            const entryProductCode = $(this).data('entryProductCode');
            // eslint-disable-next-line no-unused-vars
            const entryInitialQuantity = $(this).data('entryInitialQuantity');
            const actionEntryNumbers = $(this).data('actionEntryNumbers');
            const cartEntryActionForm = $('#cartEntryActionForm');
            const entryNumbers = actionEntryNumbers.toString().split(';');
            entryNumbers.forEach((entryNumber) => {
                // eslint-disable-next-line max-len
                const entryNumbersInput = $('<input>').attr('type', 'hidden').attr('name', 'entryNumbers').val(entryNumber);
                cartEntryActionForm.append($(entryNumbersInput));
            });
            cartEntryActionForm.attr('action', entryActionUrl).submit();
        });

        $('.js-update-entry-quantity-input').on('blur', function (e) {
            ACC.cartitem.handleUpdateQuantity(this, e);
        }).on('keyup', function (e) {
            return ACC.cartitem.handleKeyEvent(this, e);
        }).on('keydown', function (e) {
            return ACC.cartitem.handleKeyEvent(this, e);
        });
    },

    handleKeyEvent(elementRef, event) {
        // console.log("key event (type|value): " + event.type + "|" + event.which);

        // eslint-disable-next-line eqeqeq
        if (event.which == 13 && !ACC.cartitem.submitTriggered) {
            ACC.cartitem.submitTriggered = ACC.cartitem.handleUpdateQuantity(elementRef, event);
            return false;
        // eslint-disable-next-line no-else-return
        } else {
            // Ignore all key events once submit was triggered
            // eslint-disable-next-line no-lonely-if
            if (ACC.cartitem.submitTriggered) {
                return false;
            }
        }
        return true;
    },

    // eslint-disable-next-line no-unused-vars
    handleUpdateQuantity(elementRef, event) {
        const form = $(elementRef).closest('form');
        // eslint-disable-next-line no-unused-vars
        const productCode = form.find('input[name=productCode]').val();
        const initialCartQuantity = form.find('input[name=initialQuantity]').val();
        const newCartQuantity = form.find('input[name=quantity]').val();

        if (initialCartQuantity !== newCartQuantity) {
            form.submit();
            return true;
        }

        return false;
    },

    toggleBlock() {
        const holders = $('.toggle-block');
        holders.each(function () {
            // default options
            const holder = $(this);
            const slide = holder.find('.toggle-block-area');
            const btn = holder.find('.toggle-block-opener');

            if (holder.is('.active')) {
                slide.show();
                btn[0].setAttribute('aria-expanded', 'true');
            } else {
                slide.hide();
                btn[0].setAttribute('aria-expanded', 'false');
            }

            // attach events
            btn.on('click', () => {
                ACC.cartitem.clickHandler(holder, slide, btn);
            });
        });
    },

    clickHandler(holder, slide, btn) {
        // eslint-disable-next-line no-underscore-dangle
        if (!ACC.cartitem._config.testAnimate) {
            // eslint-disable-next-line no-underscore-dangle
            ACC.cartitem._config.testAnimate = true;
            if (holder.hasClass('active')) {
                holder.removeClass('active');
                btn[0].setAttribute('aria-expanded', 'false');
                slide.slideUp(400, () => {
                    // eslint-disable-next-line no-underscore-dangle
                    ACC.cartitem._config.testAnimate = false;
                });
            } else {
                holder.addClass('active');
                btn[0].setAttribute('aria-expanded', 'true');
                slide.slideDown(400, () => {
                    // eslint-disable-next-line no-underscore-dangle
                    ACC.cartitem._config.testAnimate = false;
                });
            }
        }
    },
};
$(document).ready(() => {
    $('.js-cartItemDetailBtn').click(function (event) {
        event.stopPropagation();
        const thisDetailGroup = $(this).parent('.js-cartItemDetailGroup');
        $(thisDetailGroup).toggleClass('open'); // only in its parent
        if ($(thisDetailGroup).hasClass('open')) {
            // close all if not this parent
            $('.js-cartItemDetailGroup').not(thisDetailGroup).removeClass('open');
            // change aria
            $('.js-cartItemDetailBtn').attr('aria-expanded', 'true');
        } else {
            $('.js-cartItemDetailBtn').attr('aria-expanded', 'false');
        }
        $(document).click(() => {
            $(thisDetailGroup).removeClass('open');
        }); // closes when clicking outside this div
    });

    // enable comment for this item only
    $('.js-entry-comment-button').click(function (event) {
        event.preventDefault();
        const linkID = $(this).attr('href');
        $(linkID).toggleClass('in');
        // eslint-disable-next-line no-undef
        $(thisDetailGroup).removeClass('open');
    });
});
